import {
  subscribeEvent,
  triggerEvent,
  unsubscribeEvent,
} from '@shared/event/event'
import type {
  CartEvent,
  DecreaseCartLineEvent,
  IncreaseCartLineEvent,
  ShowAddToCartSidePanelEvent,
  ViewCartEvent,
} from '@shared/event/events/types'
import type { EventCallback, EventToken } from '@shared/event/types'

const CART_EVENT = 'cart'

export const triggerCartEvent = (event: CartEvent) =>
  triggerEvent(CART_EVENT, event)

export const onCartEvent = (callback: EventCallback<CartEvent>) =>
  subscribeEvent(CART_EVENT, callback)

export const removeCartEvent = (token: EventToken<CartEvent>) =>
  unsubscribeEvent(CART_EVENT, token)

const INCREASE_CART_LINE_EVENT = 'increase_cart_line'

export const triggerIncreaseCartLineEvent = (event: IncreaseCartLineEvent) => {
  triggerCartEvent({ cart: event.cart })
  triggerEvent(INCREASE_CART_LINE_EVENT, event)
}

export const onIncreaseCartLineEvent = (
  callback: EventCallback<IncreaseCartLineEvent>
) => subscribeEvent(INCREASE_CART_LINE_EVENT, callback)

export const removeIncreaseCartLineEvent = (
  token: EventToken<IncreaseCartLineEvent>
) => unsubscribeEvent(INCREASE_CART_LINE_EVENT, token)

const DECREASE_CART_LINE_EVENT = 'decrease_cart_line'

export const triggerDecreaseCartLineEvent = (event: DecreaseCartLineEvent) => {
  triggerCartEvent({ cart: event.cart })
  triggerEvent(DECREASE_CART_LINE_EVENT, event)
}

export const onDecreaseCartLineEvent = (
  callback: EventCallback<DecreaseCartLineEvent>
) => subscribeEvent(DECREASE_CART_LINE_EVENT, callback)

export const removeDecreaseCartLineEvent = (
  token: EventToken<DecreaseCartLineEvent>
) => unsubscribeEvent(DECREASE_CART_LINE_EVENT, token)

const VIEW_CART_EVENT_NAME = 'view_cart'

export const triggerViewCartEvent = (event: ViewCartEvent) => {
  triggerEvent(VIEW_CART_EVENT_NAME, event)
}

export const onViewCartEvent = (callback: EventCallback<ViewCartEvent>) =>
  subscribeEvent(VIEW_CART_EVENT_NAME, callback)

export const removeViewCartEvent = (token: EventToken<ViewCartEvent>) =>
  unsubscribeEvent(VIEW_CART_EVENT_NAME, token)

const SHOW_ADD_TO_CART_SIDE_PANEL_EVENT = 'show_add_to_cart_side_panel'

export const triggerShowAddToCartSidePanelEvent = (
  event: ShowAddToCartSidePanelEvent
) => triggerEvent(SHOW_ADD_TO_CART_SIDE_PANEL_EVENT, event)

export const onShowAddToCartSidePanelEvent = (
  callback: EventCallback<ShowAddToCartSidePanelEvent>
) => subscribeEvent(SHOW_ADD_TO_CART_SIDE_PANEL_EVENT, callback)

export const removeShowAddToCartSidePanelEvent = (
  token: EventToken<ShowAddToCartSidePanelEvent>
) => unsubscribeEvent(SHOW_ADD_TO_CART_SIDE_PANEL_EVENT, token)
